import i18n from "i18next";
import type { FC } from "react";

import { SecondaryButton } from "../../../Buttons/components/ActionButton";

export interface TableAddNewLineButtonProps {
    callback: () => void;
}

export const TableAddNewLineButton: FC<TableAddNewLineButtonProps> = ({ callback }) => {
    return (
        <SecondaryButton onClick={callback} disabled={false}>
            {i18n.t("button.add")}
        </SecondaryButton>
    );
};
